import { useContext } from "react";
import { useGetVisualUnitsMutation, useCreateNewVisualUnitMutation } from "../Redux/Workspace/workspaceActionsSlice";
import { FoundationsGenericToaster } from "./FoundationsGenericToaster";
import { SearchListCallbacks } from "./searchlistCallbacks";
import { VisualUnitApiDTO_VisualUnit } from "../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit";
import { FoundationsConstants } from "../FoundationsConstants";
import { VisualUnitApiDTO_VisualUnit_Extended } from "../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit";
import { WorkspaceApiDTO_Workspace } from "../Interfaces/APIContracts/WorkspaceApiDTO_Workspace";
import { useWorkspaceStore } from "../Pages/Workspace/workspaceContext";
import { useCopyVisualUnitMutation } from "../Redux/ReportActions/reportActionsSlice";
declare let window: any;
const UnicornApp = window.unicornInstance as any;

const copyExistingCallbacks = (dashBoardId: number): SearchListCallbacks => {
    const [getVisualUnits] = useGetVisualUnitsMutation();
    const [createNewVisualUnit] = useCreateNewVisualUnitMutation()
    const [execCopyVisualUnit] = useCopyVisualUnitMutation()

    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
    const bulkUpdateVUs = useWorkspaceStore((s) => s.updateVisualUnits);

    const onFind = async (filterText: string) => {
        const formData = new FormData();
        formData.append('searchCriteria', 'searchString');
        formData.append('searchValue', filterText);
        const response = await getVisualUnits(formData).unwrap();
        return response.map((item: { KeyValue: any; DisplayText: any; }) => ({
            KeyValue: item.KeyValue,
            DisplayText: item.DisplayText,
        }));
    };

    const onSave = async (selectedItems: any[]) => {
        if (selectedItems.length === 1) {
            copyVisualUnit(selectedItems[0].KeyValue)
        }
    };
    const copyVisualUnit = (filterValue: any) => {
        if (filterValue) {
            createNewVisualUnitDialog(filterValue)
                .then((resultData) => {
                    if (resultData) {
                        const newReport: VisualUnitApiDTO_VisualUnit_Extended = { ...resultData.newVU }
                        newReport.callerType = FoundationsConstants.enumVUCallerType.Explore
                        newReport.DashBoardId = dashBoardId
                        
                        let updatedVUList = [...currentWorkspaceData.VisualUnits]
                        updatedVUList.push(newReport);
                        bulkUpdateVUs(updatedVUList)

                    }
                })
                .catch((err) => {
                    console.error('Error in copy existing report:', err)
                })
        }
    }
    const createNewVisualUnitDialog = (
        vuId: number,
    ) => {
        const CopyPayload = {
            WorkspaceId: '' + dashBoardId,
            VisualUnitId: vuId.toString(),
        }
        return execCopyVisualUnit({ body: CopyPayload })
            .unwrap()
            .then((response) => {
                if (response) {
                    const resultData = response.data

                    if (resultData && resultData.MessageResults.length > 0) {
                        return resultData
                    } else {
                        FoundationsGenericToaster('error', 'No message results found.')
                        return null
                    }
                } else {
                    FoundationsGenericToaster('error', 'Unexpected error occurred.')
                    return null
                }
            })
            .catch((err) => {
                FoundationsGenericToaster('error', 'Failed to create Visual Unit. Please try again.')
                throw err
            })
    }

    return {
        onFind,
        onSave,
    };
};

export default copyExistingCallbacks;